export enum ProviderType {
  Therapy = 'therapy',
  Tutor = 'tutor',
  Transportation = 'transportation'
}

export enum ProviderTypeId {
  Tutor = 1,
  Therapy = 2,
  Transportation = 3
}

export function toProviderTypeId(type: string | number | null | undefined): ProviderTypeId | null {
  if (
    type === ProviderTypeId.Tutor ||
    type === ProviderTypeId.Therapy ||
    type === ProviderTypeId.Transportation
  ) {
    return type;
  }

  const normalized = String(type ?? '')
    .trim()
    .toLowerCase();
  if (normalized === ProviderType.Tutor || normalized === '1' || normalized === 'tutoring') {
    return ProviderTypeId.Tutor;
  }
  if (normalized === ProviderType.Therapy || normalized === '2') {
    return ProviderTypeId.Therapy;
  }
  if (normalized === ProviderType.Transportation || normalized === '3') {
    return ProviderTypeId.Transportation;
  }
  return null;
}

/** Display label for provider type headers / chips. */
export function toProviderTypeLabel(type: string | null | undefined): string {
  const normalized = String(type ?? '')
    .trim()
    .toLowerCase();
  if (normalized === ProviderType.Tutor || normalized === 'tutoring') {
    return 'Tutoring';
  }
  if (normalized === ProviderType.Therapy) {
    return 'Therapy';
  }
  if (normalized === ProviderType.Transportation) {
    return 'Transportation';
  }
  return type?.trim() || '-';
}
